import React, { useState } from 'react'
import { useCookies } from 'react-cookie';
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import { optionStyles, locale } from '../customize';

export default function CheckEmployeeInfo({ cookie, values, onCompleteTutorial, isExpand, setIsExpand, setTutorialStep3 }) {
    const { run, stepIndex, tourCompleted, type, employeeId } = cookie
    const { t } = useTranslation()

    const checkTargetPath = (target) => {
        if (values && values.employee)
            return window.location.pathname == `/employees/${values.employee.id}/edit` ? target : '.none'
        else
            return '.none'
    }

    const step = [
        {
            target: checkTargetPath('a[name="BasicInfomation"] + section'),
            content: t('features.GuideTour.Employees.CheckInfoStep.0'),
            disableBeacon: true,
            placement: 'auto',
        },
        {
            target: checkTargetPath('a[name="EmploymentInfomation"] + section'),
            content: t('features.GuideTour.Employees.CheckInfoStep.1'),
            placement: 'auto',
        },
        {
            target: checkTargetPath('a[name="RemunerationInfomation"] + section'),
            content: t('features.GuideTour.Employees.CheckInfoStep.2'),
            placement: 'auto',
        },
        {
            target: checkTargetPath('a[name="BankInfomation"] + section'),
            content: (
                <React.Fragment>
                    {t('features.GuideTour.Employees.CheckInfoStep.3').split(';').map((text, index) =>
                        <p key={index} style={{ textAlign: 'left' }}>{text}</p>
                    )}
                </React.Fragment>
            ),
            placement: 'auto',
        },
        {
            target: checkTargetPath('form > section:nth-child(12) > div.Form__boxMain--FpqUy > div > div:nth-child(1) > section'),
            content: t('features.GuideTour.Employees.CheckInfoStep.4'),
            placement: 'auto',
        },
        {
            target: checkTargetPath('a[name="PaymentBankSection"] + section'),
            content: t('features.GuideTour.Employees.CheckInfoStep.5'),
            placement: 'auto',
        },
        {
            target: checkTargetPath('.u-ta-c div.Button__small--2xvZ0'),
            content: t('features.GuideTour.Employees.CheckInfoStep.6'),
            placement: 'auto',
        }
    ];

    const setStepIndex = (newIndex, id) => {
        setTutorialStep3({ run, stepIndex: newIndex, tourCompleted, type, employeeId })
    }
    const setTourCompleted = () => {
        onCompleteTutorial()
        setTutorialStep3({ run: false, stepIndex: 0, tourCompleted:true, type, employeeId })
    }
    const handleCallback = data => {
        const { action, index, lifecycle, type } = data;
        const newIndex = index + (action === 'prev' ? -1 : 1);

        if (action === 'skip') {
            setTourCompleted()
        }
        else if (type === 'step:after' && index === 0) {
            setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 1) {
            setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 2) {
            setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 3) {
            if (!isExpand) {
                document.querySelector('a[name="BankInfomation"] + section .u-txt-addinfo').click()
                setTimeout(() => setStepIndex(newIndex), 300)
                setIsExpand(true)
            }
            else {
                setStepIndex(newIndex)
            }
        }
        else if (type === 'step:after' && index === 4) {
            setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 5) {
            if (action == 'prev' && !isExpand) {
                document.querySelector('a[name="BankInfomation"] + section .u-txt-addinfo').click()
                setTimeout(() => setStepIndex(newIndex), 300)
                setIsExpand(true)
            }
            else
                setStepIndex(newIndex)
        }
        else if (type === 'step:after' && index === 6) {
            action === 'prev' ? setStepIndex(newIndex) : setTourCompleted()
        }
    };

    return (
        <Joyride
            steps={step}
            run={run && !tourCompleted}
            stepIndex={stepIndex}
            callback={handleCallback}
            styles={optionStyles}
            locale={locale(t)}
            continuous
            scrollToFirstStep
            hideCloseButton
            showProgress
            showSkipButton
            disableOverlayClose
        />
    )
}
